import { useMemo, useState } from "react";

import { useLanguage } from "@/i18n/LanguageContext";
import { pickLocalized } from "./format";
import { buildMapEmbedSrc } from "./shells/mapEmbed";
import { PageHeader } from "./shells/PageHeader";
import { useConferenceSettings } from "./useConferenceSettings";

export function VenuePage() {
  const { t, locale } = useLanguage();
  const { data: conf, loading } = useConferenceSettings();
  const [mapReady, setMapReady] = useState(false);

  const address = conf ? pickLocalized(conf, locale, "address_en", "address_ar") : "";
  const venueName = conf ? pickLocalized(conf, locale, "venue_name_en", "venue_name_ar") : "";
  const embedSrc = useMemo(
    () => (conf ? buildMapEmbedSrc(conf.map_url, address) : null),
    [conf, address],
  );

  if (loading || !conf) return <p>{t.common.loading}</p>;

  return (
    <div>
      <PageHeader title={t.venue.title} />
      <div className="dn-grid">
        <div className="dn-card">
          <h3>{venueName}</h3>
          <p className="dn-muted">{t.venue.address}</p>
          <p style={{ whiteSpace: "pre-line" }}>{address}</p>
        </div>
        <div className="dn-card">
          <h3>{t.sections.contact}</h3>
          <p>
            <a href={`mailto:${conf.contact_email}`}>{conf.contact_email}</a>
          </p>
          <p>{conf.phone_primary}</p>
          {conf.phone_secondary && <p>{conf.phone_secondary}</p>}
          <p className="dn-muted">{t.sections.director}</p>
          <p>{pickLocalized(conf, locale, "director_name_en", "director_name_ar")}</p>
        </div>
      </div>

      {embedSrc ? (
        <div className="dn-map-embed" role="region" aria-label={t.venue.mapTitle}>
          {!mapReady ? <div className="dn-map-embed-status">{t.venue.mapLoading}</div> : null}
          <iframe
            title={t.venue.mapTitle}
            src={embedSrc}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
            onLoad={() => setMapReady(true)}
          />
        </div>
      ) : null}

      <div className="dn-map-actions">
        {conf.map_url ? (
          <a className="dn-btn dn-btn-primary" href={conf.map_url} target="_blank" rel="noreferrer">
            {t.venue.map}
          </a>
        ) : embedSrc ? (
          <a
            className="dn-btn dn-btn-primary"
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address || venueName)}`}
            target="_blank"
            rel="noreferrer"
          >
            {t.venue.map}
          </a>
        ) : null}
      </div>
    </div>
  );
}
